export const ensureHttps = (url: string) => {
  const trimmed = typeof url === "string" ? url.trim() : "";
  if (!trimmed) return "#";
  if (/^(https?:\/\/|mailto:|tel:|#|\/)/i.test(trimmed)) {
    return trimmed;
  }
  if (!/^https?:\/\//i.test(trimmed)) {
    return `https://${trimmed}`;
  }
  return trimmed;
};
